import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Form, Badge, Row, Col } from "react-bootstrap";
import { timeSince } from "utils/utiuls";
import ApiGServer from "services/ApiGServer";

const CertificadoDash = () => {
  const [equipments, setEquipments] = useState([]);
  const [certificadoLabels, setCertificadoLabels] = useState([]);
  const [certificadoDataset, setCertificadoDataset] = useState([]);
  const [checkLocacao, setCheckLocacao] = useState(false);
  const [certEmDia, setCertEmDia] = useState("");
  const [certAtraso, setCertAtraso] = useState("");

  const processData = (equipments, loc) => {

    let equipamentos = [...equipments];

    if (loc) {
      equipamentos = equipamentos.filter(i => i.mode == "RENTAL")
    }

    const sampleArray = [];
    for (let index = 0; index < equipamentos.length; index++) {
      const element = equipamentos[index];

      var strData = element.dcal;
      if (strData) {
        var d = new Date(strData);

        let time = timeSince(d);

        sampleArray.push(time);
      } else {
        sampleArray.push("NaN");
      }
    }

    setCertEmDia(sampleArray.filter(i => i.includes("mês") || i.includes("meses")).length)
    setCertAtraso(sampleArray.filter(i => i.includes("ano") || i.includes("anos")).length)

    const counts = {};

    sampleArray.forEach((x) => { counts[x] = (counts[x] || 0) + 1; });

    var result = [];

    const keys = Object.keys(counts);

    keys.forEach((key, index) => {
      result.push(`${key}: ${counts[key]}`);
    });

    let meses = result.filter(i => i.includes("mês") || i.includes("meses")).sort((a, b) => { return a.split(" ")[0] - b.split(" ")[0] })
    let anos = result.filter(i => i.includes("ano") || i.includes("anos")).sort((a, b) => { return a.split(" ")[0] - b.split(" ")[0] })
    let finalArray = meses.concat(anos);

    let dataset = finalArray.map(i => i.split(":")[1]);
    setCertificadoDataset(dataset);
    let labels = finalArray.map(i => i.split(":")[0]);
    setCertificadoLabels(labels);
  }

  useEffect(() => {
    const getData = async () => {
      const { data } = await ApiGServer.get('/equipment/all');
      setEquipments(data);
      processData(data, false);
    }
    getData();
  }, []);

  const brandColors = {
    lightGreen: '#8fad15',
    darkGreen: '#1c4220',
    lighterGreen: 'rgba(143, 173, 21, 0.7)', // Verde claro com transparência
    darkerGreen: 'rgba(28, 66, 32, 0.7)', // Verde escuro com transparência
  }
  // Configurações para o gráfico modernizado
  const options = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          fontColor: '#666',
          fontFamily: 'sans-serif'
        },
        gridLines: {
          color: 'rgba(0, 0, 0, 0.05)',
          zeroLineColor: 'rgba(0, 0, 0, 0.1)'
        }
      }],
      xAxes: [{
        ticks: {
          fontColor: '#666',
          fontFamily: 'sans-serif'
        },
        gridLines: {
          display: false
        }
      }]
    },
    legend: {
      display: false
    },
    tooltips: {
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      titleFontColor: '#333',
      bodyFontColor: '#666',
      borderColor: 'rgba(0, 0, 0, 0.1)',
      borderWidth: 1,
      displayColors: true
    }
  };

  return (
    <div className="dashboard-card">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h4 className="fw-bold mb-1">Certificados de Calibração</h4>
          <div className="mt-2 mb-3">
            <Badge bg="success" className="me-2 px-3 py-2">
              <span className="fw-normal">Em dia:</span> <span className="ms-1 fw-bold">{certEmDia}</span>
            </Badge>
            <Badge bg="danger" className="px-3 py-2">
              <span className="fw-normal">Em atraso:</span> <span className="ms-1 fw-bold">{certAtraso}</span>
            </Badge>
          </div>
        </div>

        <Form.Check
          type="switch"
          id="locacao-switch"
          label="Apenas Locação"
          checked={checkLocacao}
          onChange={() => {
            setCheckLocacao(!checkLocacao)
            processData(equipments, !checkLocacao)
          }}
          className="ms-3"
        />
      </div>

      <div className="stat-card" style={{ height: '350px', background: 'white', borderRadius: '10px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
        <Bar
          data={{
            labels: certificadoLabels,
            datasets: [
              {
                label: 'Equipamentos',
                data: certificadoDataset,
                backgroundColor: brandColors.darkerGreen,
                borderColor: brandColors.darkGreen,
                borderWidth: 1,
                borderRadius: 4,
                barThickness: 20
              }
            ]
          }}
          options={options}
        />
      </div>
    </div>
  )
}

export default CertificadoDash;
